module.exports = __webpack_public_path__ + "kz.c70a8bdcbb0a76f928e8.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/kz.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/kz.svg
// module chunks = styles